







import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class CellStepper extends Vue {
    @Prop(String) private name!: string;
    @Prop({type: Number, default: 1}) private value?: number;
    @Prop(Number) private min?: number;
    @Prop(Number) private max?: number;
    private val: number = 1;

    private created() {
        (this.val as any) = this.value;
    }
    @Emit('change')
    private onChange() {
        return this.val;
    }
}
